import { gql } from "@apollo/client";

const GET_COURSES_CC = gql`
query coursesCC($schacCode: String, $baseUrl: String, $apiKey: String)
    {coursesCC(schacCode: $schacCode, baseUrl: $baseUrl, apiKey: $apiKey) {
        id
        uuid
        status
        title
        code
        course__ects
        language_of_instruction
        description
        learning_outcomes
        course__academic_term
        course__assessment_method
        course__bibliography
        course__course_availability
        course__course_content
        course__elm_assessment_type
        course__elm_activity_type
        course__elm_lo_type
        course__elm_mode_of_learning
        course__isced_code
        course__local_classification
        course__prerequisite_course
        course__prerequisites
        course__related_programme
        course__restricted_to_local
        course__restricted_to_alliance
        course__teaching_method
        url
    }  
}`
;

export default GET_COURSES_CC;
